export default __webpack_public_path__ + "static/media/search.792c9620.svg";